/* Ash: Title Case for every heading on the page.
 *
 * `text-transform: capitalize` only uppercases the first letter of
 * each word — if the source is already ALL CAPS ("BEST SELLERS"),
 * capitalize keeps it ALL CAPS. This script rewrites the heading's
 * text node to true Title Case so the CSS rule can finish the job.
 *
 * Runs once at DOMContentLoaded, again after Horizon's section
 * morphs (MutationObserver, debounced).
 */
(function () {
  if (window.__ashTitleCaseInit) return;
  window.__ashTitleCaseInit = true;

  /* Words kept lowercase in the middle of a heading (English-style
   * title case). The first word is ALWAYS capitalised regardless. */
  var STOP = new Set([
    'a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'from', 'in',
    'into', 'of', 'on', 'or', 'over', 'per', 'so', 'the', 'to', 'up',
    'via', 'vs', 'with', 'yet', 'nor'
  ]);

  function titleCase(s) {
    if (!s) return s;
    var src = String(s);
    /* If the string contains lowercase already, assume the author
     * already chose their casing — bail out. Only normalise SHOUT
     * casing where >70% of letters are uppercase. */
    var letters = src.replace(/[^A-Za-z]/g, '');
    if (letters.length === 0) return src;
    var upper = letters.replace(/[^A-Z]/g, '').length;
    if (upper / letters.length < 0.7) return src;

    return src.toLowerCase().split(/(\s+|[—–\-/·•|·])/).map(function (chunk, idx) {
      if (!chunk || /^\s+$/.test(chunk) || /^[—–\-/·•|·]$/.test(chunk)) return chunk;
      if (idx > 0 && STOP.has(chunk)) return chunk;
      return chunk.charAt(0).toUpperCase() + chunk.slice(1);
    }).join('');
  }

  var SELECTOR = 'h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, [class*="__heading"], [class*="__title"]:not(input):not(textarea):not(button)';

  function walk(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    nodes.forEach(function (el) {
      if (el.dataset.ashTitleCased === '1') return;
      /* Only transform if the element has a single text node — skip
       * headings with rich nested markup so we don't mangle them. */
      var children = Array.prototype.filter.call(el.childNodes, function (n) {
        return n.nodeType === 1 || (n.nodeType === 3 && n.nodeValue.trim());
      });
      if (children.length === 0) return;
      /* Walk text nodes only and rewrite each */
      Array.prototype.forEach.call(el.childNodes, function (n) {
        if (n.nodeType === 3) {
          var next = titleCase(n.nodeValue);
          if (next !== n.nodeValue) n.nodeValue = next;
        }
      });
      el.dataset.ashTitleCased = '1';
    });
  }

  function init() { walk(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run after Horizon's section morphs (debounced). */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      walk(document);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
